module.exports = __webpack_public_path__ + "static/media/the-new-york-times-logo.0e50b3cf.png";